import React from "react";
import { SectionTitle } from "./SectionTitle.style";
export default function ({ children }) {
  return <SectionTitle>{children}</SectionTitle>;
}
